const newContainer = () => import("@/layouts/Default.vue");
const routerParent = () => import("@/layouts/routerParrent.vue");
const searchInquiry = () => import("../views/inquiry/inquiryList.vue");
const editInquiry = () => import("../views/inquiry/components/inquiryEdit.vue");

export const centerDesAvocatsRoutes: any[] = [
  {
    path: "/center-des-avocats",
    name: "centerDesAvocats",
    meta: {
      label: "مزکز وکلا",
      requiresAuth: true,
      moduleName: "centreDesAvocats",
    },
    component: newContainer,
    children: [
      {
        path: "inquiry",
        name: "inquiry",
        component: routerParent,
        redirect: "/center-des-avocats/inquiry/search",
        meta: {
          label: "استعلام",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "search",
            name: "search_inquiry",
            component: searchInquiry,
            meta: {
              label: "استعلام‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "person/:code/edit/:id",
            name: "editInquiry",
            component: editInquiry,
            meta: {
              label: "ویرایش استعلام",
              requiresAuth: true,
              redesigned: true,
              hasBottomNavigation: false,
            },
          },
        ],
      },
    ],
  },
];
